import { FormState } from 'contexts/ConfigurationForm/types';
import { inputRules } from 'utils/rules';
import validate from 'utils/validate';

export default function validateInputs(state: FormState) {
  if (!state.productApiEnabled) {
    return null;
  }

  const errors = {};
  Object.keys(inputRules).forEach((fieldName) => {
    const fieldValue = state[fieldName];
    const fieldErrors = validate(fieldValue, inputRules[fieldName]);
    if (fieldErrors === '') {
      return;
    }

    errors[fieldName] = fieldErrors;
  });

  if (Object.keys(errors).length === 0) {
    return null;
  }
  return errors;
}
